import { useSelector } from 'react-redux'
import { Notification } from '../../../common/notification'
import { HandleDetail } from '../../common/handleDetail'
import { selectPeriod } from '../../common/period/slice'
import { TableItem } from './TableItem'
import {
  INDUSTRY_DETAIL_PATH,
  MODEL_ID,
  PORTFOLIO_DETAIL_PATH,
} from './constant'
import {
  selectHighestRiskIndustryById,
  selectHighestRiskIndustryIds,
  selectHighestRiskPortfolioById,
  selectHighestRiskPortfolioIds,
} from './store/slice'

export const CreditRisk = ({
  isDynamicReport = false,
  hasTablePortfolio = true,
  hasTableIndustry = true,
}) => {
  const period = useSelector(selectPeriod)
  const portfolioIds = useSelector(selectHighestRiskPortfolioIds)
  const industryIds = useSelector(selectHighestRiskIndustryIds)

  if (isDynamicReport) {
    const isNoDataPortfolio =
      (hasTablePortfolio && !portfolioIds?.length) || !hasTablePortfolio
    const isNoDataIndustry =
      (hasTableIndustry && !industryIds?.length) || !hasTableIndustry

    if (isNoDataPortfolio && isNoDataIndustry) {
      return <Notification isDynamicReport />
    }
  }

  return (
    <div className={`dFlex gap4 pb2 ${isDynamicReport ? 'flexColumn' : ''}`}>
      {hasTablePortfolio && (
        <div className="flex1 minW0">
          <TableItem
            isDynamicReport={isDynamicReport}
            title="portfolio.summary.HIGHEST_RISK_PORTFOLIOS"
            note="portfolio.summary.HIGHEST_RISK_PORTFOLIOS_NOTE"
            indicatorName="PORTFOLIO"
            dataColIds={{
              COL_NUMBER_OF_COMPANIES: 'numberCompanies',
              TOTAL_HIGHEST_RISK_COMPANIES: 'highestCompanies',
              NEW_HIGHEST_RISK_COMPANIES: 'newHighestCompanies',
            }}
            ids={portfolioIds}
            getDataFromRedux={selectHighestRiskPortfolioById}
            renderDetail={({ rowId, colId, data }) => {
              return (
                <HandleDetail
                  path={PORTFOLIO_DETAIL_PATH[colId]}
                  otherParams={{
                    timeFrequency: period,
                    portfolioId: rowId,
                    modelId: MODEL_ID.CORPORATE_RISK,
                  }}
                  isDynamicReport={isDynamicReport}
                >
                  {data}
                </HandleDetail>
              )
            }}
          />
        </div>
      )}
      {hasTableIndustry && (
        <div className="flex1 minW0">
          <TableItem
            isDynamicReport={isDynamicReport}
            title="portfolio.summary.HIGHEST_RISK_INDUSTRIES"
            subTitle="portfolio.summary.HIGHEST_RISK_INDUSTRIES_SUB"
            note="portfolio.summary.HIGHEST_RISK_INDUSTRIES_NOTE"
            indicatorName="INDUSTRY"
            dataColIds={{
              COL_NUMBER_OF_COMPANIES: 'numberCompanies',
              TOTAL_HIGHEST_RISK_COMPANIES: 'highestCompanies',
              NEW_HIGHEST_RISK_COMPANIES: 'newHighestCompanies',
            }}
            ids={industryIds}
            getDataFromRedux={selectHighestRiskIndustryById}
            renderDetail={({ rowId, colId, data }) => {
              return (
                <HandleDetail
                  path={INDUSTRY_DETAIL_PATH[colId]}
                  otherParams={{
                    timeFrequency: period,
                    vsicId: rowId,
                    modelId: MODEL_ID.CORPORATE_RISK,
                  }}
                  disabled={colId === 'numberCompanies'}
                  hiddenSelectAll
                  isDynamicReport={isDynamicReport}
                >
                  {data}
                </HandleDetail>
              )
            }}
          />
        </div>
      )}
    </div>
  )
}
